import React from 'react';
import SEO from './SEO';

const EMAIL = process.env.REACT_APP_EMAIL;
const WEBSITE_WITH_ENDING = process.env.REACT_APP_WEBSITE_WITH_ENDING;

function PolitykaPrywatnosci() {
  return (
    <>
      <div className="article-container">
        {/* Dokument formalny: noindex,follow + wlasny canonical. */}
        <SEO
          title={`Polityka prywatności ${WEBSITE_WITH_ENDING}`}
          description="Zasady przetwarzania danych osobowych w serwisie sensorini.pl."
          pathname="/polityka-prywatnosci/"
          type="website"
          noindex
        />
        <h1>{`Polityka Prywatności ${WEBSITE_WITH_ENDING}`}</h1>

        <h4>Postanowienia ogólne</h4>
        <p>
          Zachowujemy prawo do prywatności użytkowników oraz zgodności z przepisami prawa. Dane osobowe przekazane przez użytkowników są gromadzone i przetwarzane zgodnie z RODO.
        </p>

        <h4>Informacje kontaktowe</h4>
        <p>
          Administrator danych: {WEBSITE_WITH_ENDING}, kontakt: {EMAIL}
        </p>

        <h4>Zakres gromadzonych danych osobowych</h4>
        <p>
          Gromadzimy dane niezbędne do świadczenia usług, w tym dane kontaktowe. Dane są przetwarzane w celu poprawy funkcjonowania serwisu, marketingu usług oraz prowadzenia dokumentacji księgowej.
        </p>

        <h4>Uprawnienia użytkownika</h4>
        <p>
          Przysługują Ci prawa do: dostępu, sprostowania, usunięcia, ograniczenia przetwarzania danych, przenoszenia danych, odwołania zgody, wniesienia skargi do UODO.
        </p>

        <h4>Udostępnianie danych</h4>
        <p>
          Dane mogą być udostępniane zewnętrznym dostawcom usług, z którymi współpracujemy, gwarantując bezpieczeństwo przetwarzanych danych.
        </p>

        <h4>Zgoda na przetwarzanie danych osobowych</h4>
        <p>
          Zgoda na przetwarzanie danych jest dobrowolna i może być w każdej chwili wycofana.
        </p>

        <h4>Bezpieczeństwo danych osobowych</h4>
        <p>
          Zapewniamy bezpieczeństwo danych przez stosowanie odpowiednich środków technicznych i organizacyjnych.
        </p>

        <h4>Kontakt e-mailowy</h4>
        <p>
          Dane przekazane mailowo są przetwarzane w celu kontaktu, a ich podstawą jest zgoda użytkownika.
        </p>

        <h4>Profilowanie</h4>
        <p>
          Dokonujemy profilowania w celu dostosowania treści marketingowych do preferencji użytkownika.
        </p>

        <h4>Logi serwera</h4>
        <p>
          Informacje o odwiedzinach (np. adres IP) są zapisywane w logach serwera w celu administrowania serwisem.
        </p>

        <h4>Newsletter</h4>
        <p>
          Zapis do newslettera wymaga podania adresu e-mail. Możesz w każdej chwili zrezygnować z subskrypcji.
        </p>

        <h4>Pliki cookie</h4>
        <p>
          Używamy plików cookie do analizy statystyk serwisu oraz dostosowania treści marketingowych. Możesz zarządzać ustawieniami plików cookie w swojej przeglądarce.
        </p>

        <h4>Dane osobowe a mechanizm plików cookies</h4>
        <p>
          Dane zbierane przez pliki cookies mogą być przetwarzane w celu zapewnienia prawidłowego działania strony.
        </p>

        <h4>Postanowienia końcowe</h4>
        <p>
          Możliwe są zmiany w polityce prywatności, o których użytkownicy będą informowani. Dane mogą być udostępniane organom państwowym w razie konieczności.
        </p>
      </div>
    </>
  );
}

export default PolitykaPrywatnosci;
